import { Component, OnInit } from '@angular/core';
import { Routes } from 'src/app/constantes/routes.enum';

@Component({
  selector: 'app-bouton-retour-coordonnees',
  templateUrl: './bouton-retour-coordonnees.component.html',
  standalone: false,
})
export class BoutonRetourCoordonneesComponent implements OnInit {
  urlCoordonnees: string = '';

  constructor() {}

  ngOnInit() {
    // On démarre une nouvelle navigation, on doit donc passer manuellement les query params
    this.urlCoordonnees = Routes.COORDONNEES + globalThis.location.search;
  }
}
